const HOST = 'https://www.eyouglobal.com/api/'

export default {
  topPosition: `${HOST}position/getTopPosition`,
  department: `${HOST}position/getDepartment`,
  getDepInfo: `${HOST}position/getPosition`,
  //blog
  articleCate: `${HOST}blog/getBlogLm`,
  articleList: `${HOST}blog/getBlog`,
  topArticle: `${HOST}blog/getTopBlog`,
  articleDetail: `${HOST}blog/getBlogDetail`,
  getComment: `${HOST}blog/getReply`,
  setComment: `${HOST}blog/saveReply`,
  //点赞和踩
  setLike: `${HOST}reply/updateLike`,

  //游戏
  gameArtcleCate: `${HOST}article/getArticleLm`,
  gameArticleList: `${HOST}article/getArticle`,
  gameTopArticle: `${HOST}article/getTopArticle`,
  gameArticleDetail: `${HOST}article/getArticleDetail`,
  gameGetComment: `${HOST}article/getReply`,
  gameSetComment: `${HOST}article/saveReply`,

  //招聘
  getPosition: `${HOST}job/getSelectPosition`,
  uploadFiles: `${HOST}job/fileUpload`,
  submit: `${HOST}job/save`
}


